import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Checkbox,
  FunnelModifiedIcon,
  FunnelSimpleIcon,
  IconButtonV2,
  Layout,
  OverlayPopover,
  Popover,
  Search,
} from '@utilities';

import styles from './_index.module.scss';

const NarrativesSearchBar = ({
  availableTags = null,
  handleToggleTag = () => {},
  hasTagLoadError = false,
  placeholderValue,
  searchValue = '',
  selectedTags = [],
  setSearchValue,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const buttonRef = useRef();

  return (
    <div className={styles['search-input-container']}>
      <Search
        className={styles['search-input']}
        isClearable={false}
        isIconVisible={false}
        onChange={setSearchValue}
        placeholder={placeholderValue}
        value={searchValue}
      />
      {Array.isArray(availableTags) ? (
        <>
          <IconButtonV2
            aria-label="Filter topics"
            className={classNames(styles['tags-filter-button'], {
              [styles['is-active']]: isPopoverOpen,
            })}
            disabled={hasTagLoadError || availableTags.length === 0}
            icon={selectedTags.length > 0 ? <FunnelModifiedIcon /> : <FunnelSimpleIcon />}
            onClick={() => setIsPopoverOpen((prev) => !prev)}
            ref={buttonRef}
            size="small"
            tooltip={
              hasTagLoadError && 'Tags are unavailable right now. Please refresh and try again.'
            }
            tooltipProps={{ placement: 'bottom' }}
            variant="subtle"
          />
          <OverlayPopover
            className={styles['tags-popover']}
            header="FILTER BY TAG"
            isActive={isPopoverOpen}
            onHide={() => setIsPopoverOpen(false)}
            target={buttonRef.current}
          >
            <Layout.Flex className={styles['tags-popover-content']} direction="column" gap="small">
              {availableTags.map((tag) => (
                <Popover.Item as="div" key={tag.value}>
                  <Checkbox
                    id={`narratives-topics-filter-${tag.value}`}
                    isChecked={selectedTags.includes(tag.value)}
                    label={tag.label}
                    onChange={handleToggleTag}
                    value={tag.value}
                  />
                </Popover.Item>
              ))}
            </Layout.Flex>
          </OverlayPopover>
        </>
      ) : null}
    </div>
  );
};

NarrativesSearchBar.propTypes = {
  availableTags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  handleToggleTag: PropTypes.func,
  hasTagLoadError: PropTypes.bool,
  placeholderValue: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  selectedTags: PropTypes.arrayOf(PropTypes.string),
  setSearchValue: PropTypes.func.isRequired,
};

export default NarrativesSearchBar;
